import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const LeadIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth="1.2"
                d="M11.988 21.58c5.56 0 10.068-1.134 10.068-2.532 0-1.399-4.508-2.532-10.068-2.532S1.92 17.649 1.92 19.048c0 1.398 4.508 2.532 10.068 2.532z"
            ></path>
            <path
                fill={color}
                d="M11.988 7.897a3.048 3.048 0 100-6.096 3.048 3.048 0 000 6.096zM11.988 20.292a3.314 3.314 0 01-3.096-2.136l-2.736-7.248a1.418 1.418 0 011.332-1.92h8.988c.996 0 1.68.996 1.332 1.92l-2.736 7.248a3.302 3.302 0 01-3.096 2.136h.012z"
            ></path>
        </svg>
    );
};

export default React.memo(LeadIcon);
